import { ComponentRenderHooks } from "@/plugins/types";
import settings from "./settings";
import { ComponentTypes } from "@/Apps/Pages/Editor/types";
import { IconComponent, Properties } from "./component";

export const onListItems = (hook, payload, actions) => {
  if (hook.id === ComponentRenderHooks.WEBCOMPONENT) {
    return [settings];
  }
};

export const onComponentRender = (hook, payload, actions) => {
  if (
    hook.id === ComponentRenderHooks.WEBCOMPONENT &&
    payload.type === ComponentTypes.ICON
  ) {
    return [IconComponent];
  }

  if (
    hook.id === ComponentRenderHooks.PROPERTIES &&
    hook.type === ComponentTypes.ICON
  ) {
    return Properties(payload);
  }
};
